import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Avatar from "@material-ui/core/Avatar";
import Divider from "@material-ui/core/Divider";
import LinearProgress from "@material-ui/core/LinearProgress";
import { connect } from "react-redux";
import Axios from "axios";
import jwtDecode from "jwt-decode";

import { url } from "../../../../config/config";
import { authorLogin } from "../../../../redux/action/action";
import { withRouter } from "react-router-dom";
import { useStyles } from "./EditForm.css";
import FormLoader from "../../../../Component/FormLoader/FormLoader";

const CustomLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#1a90ff",
  },
}))(LinearProgress);

class AuthorEditForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        profileImageUrl: "",
        firstName: "",
        middleName: "",
        lastName: "",
        username: "",
        email: "",
        phone: "",
        description: "",
      },
      authorId: "",
      firstNameError: "",
      lastNameError: "",
      phoneError: "",
      descriptionError: "",
      percentage: 0,
      success: "",
      loading: false,
    };
  }

  async componentDidMount() {
    this.decodeToken();
  }

  decodeToken = async () => {
    try {
      let authorData = await jwtDecode(this.props.authorToken);
      const response = await Axios.get(`${url}/api/authors/${authorData._id}`);
      if (response.data) {
        this.setState({
          data: {
            firstName: response.data.firstName,
            middleName: response.data.middleName,
            lastName: response.data.lastName,
            email: response.data.email,
            profileImageUrl: response.data.imageUrl,
            phone: response.data.phone,
            description: response.data.description,
          },
          authorId: response.data._id,
          isEmpty: true,
          fileSize: 0,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  handleUpload = (e) => {
    let reader = new FileReader();
    this.setState({
      data: { ...this.state.data, profileImage: e.target.files[0] },
    });
    let files = e.target.files[0];
    reader.onload = (e) => {
      this.setState({
        data: {
          ...this.state.data,
          profileImageUrl: e.target.result,
        },
      });
    };

    reader.onprogress = (data) => {
      if (data.lengthComputable) {
        var progress = parseInt((data.loaded / data.total) * 100, 10);
        this.setState({
          percentage: progress,
        });
      }
    };

    if (files) {
      reader.readAsDataURL(files);
    }
  };

  handleProgress = () =>
    this.state.percentage ? (
      <React.Fragment>
        <CustomLinearProgress
          value={this.state.percentage}
          variant="determinate"
        />
        {this.state.percentage === 100 ? (
          <React.Fragment>Upload Complete</React.Fragment>
        ) : (
          <React.Fragment>{this.state.percentage}%</React.Fragment>
        )}
      </React.Fragment>
    ) : null;

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  checkError = (EmailError, PhoneError) => {
    let firstNameError = EmailError;
    let lastNameError = "";
    let phoneError = PhoneError ? "Use Only Numbers" : "";
    let descriptionError = "";

    if (this.state.data.firstName.length < 3) {
      firstNameError = "First Name must be minimum of 3 characters";
    }
    if (this.state.data.lastName.length < 3) {
      lastNameError = "Last Name must be minimum of 3 characters";
    }
    if (this.state.data.phone < 10) {
      phoneError = "Phone Number must be of minimum length 10";
    }
    if (this.state.data.description.length < 3) {
      descriptionError = "Description must be of minimum length 3";
    }

    if (firstNameError || lastNameError || phoneError || descriptionError) {
      this.setState({
        firstNameError,
        lastNameError,
        phoneError,
        descriptionError,
      });
      return true;
    } else {
      this.setState({
        firstNameError: "",
        lastNameError: "",
        phoneError: "",
        descriptionError: "",
      });
      return false;
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      this.setState({ loading: true });
      let data = {
        firstName: this.state.data.firstName,
        middleName: this.state.data.middleName,
        lastName: this.state.data.lastName,
        email: this.state.data.email,
        phone: this.state.data.phone,
        description: this.state.data.description,
        imageUrl: this.state.data.profileImageUrl,
      };
      const response = await Axios.put(
        `${url}/api/authors/edit/${this.state.authorId}`,
        data,
        {
          headers: {
            "x-auth-token": this.props.authorToken,
          },
        }
      );
      if (response.data.emailError || response.data.errors) {
        if (response.data.emailError) {
          this.checkError(response.data.emailError, "");
          this.setState({ loading: false });
        } else {
          this.checkError("", response.data.message);
          this.setState({ loading: false });
        }
      } else {
        if (response.data.token && errorStatus === false) {
          this.setState({ success: "Changed Successfully" });
          this.props.authorLogin(response.data.token);
          this.props.history.push("/profile");
        }
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <Paper style={{ padding: 20 }}>
        <div style={{ fontSize: 18, fontWeight: "bold" }}>
          Edit Your Profile
        </div>
        <div className={classes.root}>
          <div className={classes.editFormStyle}>
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  padding: 20,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Avatar style={{ width: 200, height: 200 }}>
                  <img
                    src={this.state.data.profileImageUrl}
                    alt="Profile"
                    style={{ width: 200, height: 200 }}
                  />
                </Avatar>
              </div>
              <div
                style={{
                  padding: 20,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <input
                  type="file"
                  accept="image/*"
                  id="imageUpload"
                  style={{ display: "none" }}
                  onChange={this.handleUpload}
                />
                <div>{this.handleProgress()}</div>
                <label htmlFor="imageUpload">
                  <Button className={classes.buttonStyle} component="span">
                    Upload or edit image
                  </Button>
                </label>
              </div>
            </div>
            <br />
            <Divider />
            <form onSubmit={this.handleSubmit}>
              <TextField
                name="firstName"
                label="First Name"
                type="text"
                required
                margin="normal"
                variant="outlined"
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                className={classes.inputWithMargin}
                value={this.state.data.firstName || ""}
                onChange={this.handleChange}
              />

              <TextField
                name="middleName"
                label="Middle Name"
                type="text"
                margin="normal"
                variant="outlined"
                helperText="This is optional"
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                className={classes.inputWithMargin}
                value={this.state.data.middleName || ""}
                onChange={this.handleChange}
              />

              <TextField
                name="lastName"
                label="Last Name"
                type="text"
                margin="normal"
                required
                variant="outlined"
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.lastName || ""}
                onChange={this.handleChange}
              />

              <TextField
                name="email"
                label="Email"
                type="email"
                fullWidth
                disabled
                margin="normal"
                variant="outlined"
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.email || ""}
              />

              <TextField
                name="phone"
                label="Phone"
                type="tel"
                fullWidth
                margin="normal"
                variant="outlined"
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.phone || ""}
                onChange={this.handleChange}
              />

              <TextField
                name="description"
                type="string"
                label="Bio"
                multiline
                fullWidth
                margin="normal"
                rows={4}
                rowsMax={8}
                variant="outlined"
                placeholder="Enter author's bio"
                style={{ outline: "none" }}
                error={this.state.descriptionError ? true : false}
                helperText={this.state.descriptionError}
                InputProps={{
                  classes: {
                    focused: classes.focused,
                    notchedOutline: classes.notchedOutline,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.description}
                onChange={this.handleChange}
              />

              <div style={{ display: "flex", alignItems: "center" }}>
                <Button
                  type="submit"
                  variant="outlined"
                  className={classes.buttonStyle}
                >
                  Modify
                </Button>
                {this.state.loading && <FormLoader />}
              </div>
            </form>
            <br />
          </div>
        </div>
      </Paper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authorToken: state.AuthorReducer.authorToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authorLogin: (authorToken) => {
      dispatch(authorLogin(authorToken));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(AuthorEditForm)));
